<template>
  <button :type="nativeType" @click="handleClick" class="my-button-box">
    <slot></slot>
  </button>
</template>
<script>
// <Button3></Button3>

export default {
  name: 'Button3',
  props: {
    nativeType: {
      type: String,
      default: 'button'
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  },
  mounted () {

  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
//
.my-button-box{
  height: 40px;
  line-height: 40px;
  border: none;
  background:#fff;
  border: 1px solid #e4e7ed;
  padding: 0 21px;
  border-radius: 4px;
  color: #969696;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  &:hover{
    border: 1px solid #0286df;
    color:#0286df;
    background: rgba(2, 134, 223, 0.1);
  }
}
</style>
